import { render, staticRenderFns } from "./ProjectConfig.vue?vue&type=template&id=321af272&scoped=true"
import script from "./ProjectConfig.vue?vue&type=script&lang=js"
export * from "./ProjectConfig.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfig.vue?vue&type=style&index=0&id=321af272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321af272",
  null
  
)

export default component.exports